import { ResponseCode } from "../common/constant"
import { StoreState, AppEnv }  from "./index"
import { ErrorModel, OperateResultPlayod, ScreenInfo, ScreenSize } from "../common"
import { createStore } from 'vuex'
import { NotificationMessageItem } from "../components/Notification";
import { MenuItem, SiteModule,  } from "../components/Menu";
import { SiteInfo } from "../app/appIndex"
import { UserInfo } from "../pages/login"
import { RoutePlayod } from "../route"

const store = createStore<StoreState>({
    state:function() {
        return {
            isPhone:false,
            displayName:"",
            externalState:false,
            appInitState:false,
            
            isLogin: false,
            userInfo: { 
                IsAuthenticated:false, 
                UserName:"",
                NickName:"",
                Depart:[],
                Role:[],
                DepartInfos:[],
                Roles:[],
                Leaders:[]
            },

            baseUrl: "",
            requestVerificationToken: "",

            siteInfo:{
                SiteName:"",
                SiteLogo:"",
                CssList:[],
                JsList:[],
                PhoneLogin:false,
                PhoneRegister:false,
                ThirdPartyLogin:false,
                OnlyThirdPartyLogin:false
            },

            thirdPartyLogin:false,

            noticeCounter:0,
            noticeNeedConfirm:false,
            noticeList:[],
            appState: ResponseCode.Success,
            warnMessages:[],
            errorMessages:[],

            routeInfo:{
                human:false,
                name:"",
                params:{}
            },
            routePath:"",

            isWeChatEnv:false,
            appEnv: AppEnv.None,
            screenInfo:{
                screenSize:ScreenSize.xs,
                width:0,
                height:0
            },
            supportCamera:true,

            currentModule:"",
            modules:[],

            menuExpandState:true,
            menuItems:{},
            flatMenuItems:[],
            hasInitMenu:false,

            notificationMessage:{
                notificationState:0,
                notificationType:0,
                summary:"",
                textBody:"",
                htmlBody:"",
                isHtmlPreferred:false
            },
            asyncNotificationCounter:0,

            humanLogOut:false,
            logOutEventCounter:0,

            cacheTab:"null",
            noCacheTab: "null1"
        }
    },
    mutations: {
        SetUserInfo:function (state:StoreState, userInfo:UserInfo) {
            state.isLogin = true;
            state.userInfo = userInfo
        },

        LogOut: function (state:StoreState, human: boolean) {
            state.logOutEventCounter = state.logOutEventCounter + 1;
            state.isLogin = false;

            state.humanLogOut = human;
            state.appState = ResponseCode.UnLogin;
            state.userInfo = { 
                IsAuthenticated:false, 
                UserName:"",
                NickName:"",
                Depart:[],
                Role:[],
                DepartInfos:[],
                Roles:[],
                Leaders:[]
            };
        },

        SetAppInitState: function (state:StoreState, appInitState:boolean) {
            state.appInitState = appInitState;
        },

        SetCurrentRoute(state:StoreState, routePlayod:RoutePlayod){
            state.routeInfo = routePlayod.routeInfo;
            state.routePath = routePlayod.routePath;
        },

        SetScreenInfo:function(state:StoreState,screenInfo:ScreenInfo){
            state.screenInfo = screenInfo;
        },

        SetWeChatState:function(state:StoreState,isWeChat:boolean){
            state.isWeChatEnv = isWeChat;
        },

        NotFound: function (state:StoreState) {
            state.appState = ResponseCode.NotFound;
        },

        UnAuthoized: function (state:StoreState) {
            state.appState = ResponseCode.UnAuthoized;
        },

        SetExternal:function(state:StoreState){
            state.externalState = true;
        },

        SetBaseUrl: function (state:StoreState, baseUrl:string) {
            state.baseUrl = baseUrl;
        },

        SetVerification: function (state:StoreState, requestVerificationToken:string) {
            state.requestVerificationToken = requestVerificationToken;
        },

        SetSiteInfo:function(state:StoreState, siteInfo:SiteInfo) {
            state.siteInfo = siteInfo;
        },
        
        SetWarnState:function(state:StoreState,warnMessages:Array<ErrorModel>){
            state.noticeCounter ++;
            state.appState = ResponseCode.SuccessAndWarn;
            state.warnMessages = warnMessages;
            state.errorMessages = [];
        },

        SetErrorState:function(state:StoreState,playod:OperateResultPlayod){
            state.noticeCounter ++;
            state.appState = ResponseCode.Error;
            state.noticeNeedConfirm = playod.NoticeNeedConfirm;
            state.warnMessages = playod.WarnMessages;
            state.errorMessages = playod.ErrorMessages;
        },

        ClearMessages:function(state:StoreState){
            state.noticeNeedConfirm = false;
        },

        SetDisplayName:function(state:StoreState,displayName:string){
            state.displayName = displayName;
            document.title = displayName;
        },

        SetSupportCameraState:function(state:StoreState,cameraState:boolean){
            state.supportCamera = cameraState
        },

        SetAppEnv:function(state:StoreState,appEnv:AppEnv) {
            state.appEnv = appEnv;
        },

        SetModules:function(state:StoreState,modules:Array<SiteModule>){
            state.modules = modules
        },

        SetMenuItems:function(state:StoreState,menuItems:Object){
            state.menuItems = menuItems
        },

        SetFlatMenuItems:function(state:StoreState,flatMenuItems:Array<MenuItem>){
            state.hasInitMenu = true;
            state.flatMenuItems = flatMenuItems
        },

        SetCurrentModule:function(state:StoreState,currentModule:string){
            state.currentModule = currentModule;
        },

        ToggleMenuState:function(state:StoreState){
            state.menuExpandState = !state.menuExpandState;
        },

        setRuntimeDev:function(state:StoreState, isPhone:boolean){
            state.isPhone = isPhone
        },

        setNotificationMessage:function(state:StoreState, notification:NotificationMessageItem){
            state.asyncNotificationCounter ++ ;
            state.notificationMessage = notification;
        },

        setCacheTab:function(state:StoreState, cacheTab:string){
            state.noCacheTab = state.cacheTab;
            state.cacheTab = cacheTab;
        }
    }
});

export default store
